import { useCallback } from 'react';

const useRemoveFromCart = (
  cartData: MemberShipDataTypes[],
  setCartData: React.Dispatch<React.SetStateAction<MemberShipDataTypes[]>>
) => {
  const handleClickRemoveFromCart = useCallback(
    (selectedIndex: number) => {
      if (selectedIndex < 0 || selectedIndex >= cartData.length) {
        return;
      }

      const updatedMembershipData = cartData.filter((_, index) => index !== selectedIndex);

      setCartData(updatedMembershipData);
    },
    [cartData, setCartData]
  );

  return handleClickRemoveFromCart;
};

export default useRemoveFromCart;
